import React, {
   createContext,
   PropsWithChildren,
   useContext,
   useRef
} from 'react'

import GlobalSearchUIStore from '../../stores/GlobalSearchUIStore/GlobalSearchUIStore'

const GlobalSearchUIStoreContext = createContext<GlobalSearchUIStore | null>(
   null
)

interface GlobalSearchUIStoreProviderProps extends PropsWithChildren {}

export const GlobalSearchUIStoreProvider = (
   props: GlobalSearchUIStoreProviderProps
): React.ReactElement => {
   const globalSearchUIStore = useRef(
      GlobalSearchUIStore.createGlobalSearchUIStore()
   )

   return (
      <GlobalSearchUIStoreContext.Provider value={globalSearchUIStore.current}>
         {props.children}
      </GlobalSearchUIStoreContext.Provider>
   )
}

export const useGlobalSearchUIStore = (): GlobalSearchUIStore => {
   const globalSearchUIStore = useContext(GlobalSearchUIStoreContext)

   if (!globalSearchUIStore) {
      throw new Error('Expected to be wrapped in GlobalSearchUIStoreProvider')
   }

   return globalSearchUIStore
}
